/* eslint-disable */

export const fetchResources = (nid) => {
    /**
    return new Promise((resolve) => {
        let r = {
            "201": {
                title: "Alphago",
                subtitle: "Siam (2nd year Chemistry)",
                type: {
                    id: 'documentary',
                    label: 'Documentary'
                },
                tags: [
                    "Computer Science",
                    "Philosophy and Theology",
                    "Engineering",
                    "Material Science",
                    "Physics"
                ],
                links: {
                    0: {
                        type: 'video',
                        link: 'https://youtu.be/WXuK6gekU1Y',
                        source: 'youtube',
                        id: 'WXuK6gekU1Y'
                    }
                },
                image: {
                    url: ''
                },
                body: {
                    content: 'This is a documentary about the Oxford company ‘Deep Mind’ creating an AI to beat the worlds best player at the worlds hardest most complicated game, Go. Go is an ancient game similar to chess and originated from East Asia. I found it very motivating and entertaining, as the documentary not only follows the journey of the Deep Mind, but also follows the internal journey of the worlds best player facing the AI, and how he approached AI with arrogance, which turned to concern, which evolved to resilience.',
                    style: 'quote'
                }

            },
            "202": {
              title: "Alphago",
              subtitle: "Siam (2nd year Chemistry)",
              type: {
                  id: 'documentary',
                  label: 'Documentary'
              },
              tags: [
                  "Computer Science",
                  "Philosophy and Theology",
                  "Engineering",
                  "Material Science",
              ],
              links: {
                  0: {
                      type: 'video',
                      link: 'https://youtu.be/WXuK6gekU1Y',
                      source: 'youtube',
                      id: 'WXuK6gekU1Y'
                  }
              },
              image: {
                  url: ''
              },
              body: {
                  content: 'This is a documentary about the Oxford company ‘Deep Mind’ creating an AI to beat the worlds best player at the worlds hardest most complicated game, Go. Go is an ancient game similar to chess and originated from East Asia. I found it very motivating and entertaining, as the documentary not only follows the journey of the Deep Mind, but also follows the internal journey of the worlds best player facing the AI, and how he approached AI with arrogance, which turned to concern, which evolved to resilience.',
                  style: 'quote'
              }
          },
          "203": {
            title: "Alphago",
            subtitle: "Siam (2nd year Chemistry)",
            type: {
                id: 'documentary',
                label: 'Documentary'
            },
            tags: [
                "Computer Science",
                "Engineering",
                "Material Science",
                "Physics"
            ],
            links: {
                0: {
                    type: 'video',
                    link: 'https://youtu.be/WXuK6gekU1Y',
                    source: 'youtube',
                    id: 'WXuK6gekU1Y'
                }
            },
            image: {
                url: ''
            },
            body: {
                content: 'This is a documentary about the Oxford company ‘Deep Mind’ creating an AI to beat the worlds best player at the worlds hardest most complicated game, Go. Go is an ancient game similar to chess and originated from East Asia. I found it very motivating and entertaining, as the documentary not only follows the journey of the Deep Mind, but also follows the internal journey of the worlds best player facing the AI, and how he approached AI with arrogance, which turned to concern, which evolved to resilience.',
                style: 'quote'
            }

        },
        "204": {
            title: "The Bonfire of Destiny",
            subtitle: "Nadia (1st year French)",
            type: {
                id: 'film',
                label: 'Film'
            },
            tags: [
                "History",
                "Modern Languages"
            ],
            links: {
                0: {
                    type: 'link',
                    link: 'https://www.imdb.com/title/tt9050352/'
                }
            },
            image: {
                url: ''
            },
            body: {
                content: 'This is a dramatised series based on a real historical event. It’s good for French speakers to continue listening to French voices and engaging for a historian interested in French history.',
                style: 'quote'
            }

        }
        };
        resolve(r);
    });
    */
    return fetch('/page-app/student-resource/' + nid, { //@todo replace this with dynamic remote
        method: 'GET',
        headers: {
          'Accept': 'text/plain',
          'Content-Type': 'application/json',
        }
      })
      .then((response) => {
        if (!response.ok) {
          return {};
        }
        return response.json();
      })
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => { console.error(error); throw error; });
  
}

